import { FormAction, PerformanceCategoriesSupport, QuestionSupport } from '@app/shared/enums';
import { PeFormWorkflowStepApiModel } from '../pe-forms/PeFormWorkflowStepApiModel';
import { PeFormQuestionBaseApiModel } from '../pe-forms/PeFormQuestionBaseApiModel';
import { AclItemApiModel } from '../../AclItemApiModel';

export class PpFormApiModel {
  public Id: number;
  public Name: string;
  public Description: string;
  public WhatIsSubject: Array<AclItemApiModel>;
  public HideFromSupervisors: boolean;
  public IsActive: boolean;
  public IsMandatory: boolean;
  public HasInstanceNumber: boolean;
  public HasCreatorNarrative: boolean;
  public HasSubjectNarrative: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public FormAction: FormAction;
  public HasSummarySupportingDocuments: boolean;
  public HasCitizenFeedback: boolean;
  public WorkflowSteps: Array<PeFormWorkflowStepApiModel>;
  public Questions: Array<PeFormQuestionBaseApiModel>;
  public AllowHeaderEdits: boolean;

  public deserialize(data: object): PpFormApiModel {
    Object.assign(this, data);

    this.WhatIsSubject = this.WhatIsSubject?.map((x) => new AclItemApiModel().deserialize(x));
    this.WorkflowSteps = this.WorkflowSteps?.map((x) => new PeFormWorkflowStepApiModel().deserialize(x));

    return this;
  }
}
